import gql from 'graphql-tag';
import { CustomAttribute } from '../../../models/customAttribute';
import {
  META_GARMENT_ID_KEY,
  META_NAMESPACE,
  META_STATUS_KEY,
} from '../../../utils/types';
import { Metafield } from '../../../models/metafield';

const OrderLineItemsFragment = gql`
  fragment LineItems on LineItemConnection {
    edges {
      cursor
      node {
        id
        title
        sku
        quantity
        image {
          id
          url
        }
        customAttributes {
          key
          value
        }
        variantTitle
        product {
          productType
          id
          vendor
          isSentItem: metafield(
            namespace: "${META_NAMESPACE}"
            key: "${META_STATUS_KEY}"
          ) {
            value
          }
          garmentId: metafield(
            namespace: "${META_NAMESPACE}"
            key: "${META_GARMENT_ID_KEY}"
          ) {
            value
          }
        }
        originalUnitPriceSet {
          shopMoney {
            amount
            currencyCode
          }
        }
      }
    }
    pageInfo {
      hasNextPage
    }
  }
`;

export default OrderLineItemsFragment;

export type OrderLineItem = {
  id: string,
  title: string,
  sku: string,
  quantity: number,
  image: {
    id: string,
    url: string,
  },
  customAttributes: CustomAttribute[],
  variantTitle: string,
  product?: {
    productType: string,
    id: string,
    vendor: string,
    isSentItem: Metafield,
    garmentId: string,
  },
  originalUnitPriceSet: {
    shopMoney: {
      amount: number,
      currencyCode: string,
    },
  },
};